"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: Object.getOwnPropertyDescriptor(all, name).get
    });
}
_export(exports, {
    get addNonceToUrl () {
        return addNonceToUrl;
    },
    get customMapConfig () {
        return customMapConfig;
    },
    get generateDisplayName () {
        return generateDisplayName;
    },
    get textColor () {
        return textColor;
    },
    get textFont () {
        return textFont;
    },
    get textHaloColor () {
        return textHaloColor;
    },
    get textOpacity () {
        return textOpacity;
    },
    get transparent () {
        return transparent;
    }
});
const _constants = require("common/constants");
const _queryBuilder = require("common/utils/queryBuilder");
const _styling = require("./styling");
const cleanType = (content)=>content;
const textColor = "#ffffff";
const textFont = [
    "DIN Offc Pro Bold",
    "Arial Unicode MS Regular"
];
const textHaloColor = "hsla(0, 0%, 2%, 0.82)";
const transparent = _constants.DEFAULT_MAP_STYLES.fillColor;
const textOpacity = cleanType([
    "step",
    [
        "zoom"
    ],
    0,
    12,
    1
]);
const includePointFilter = cleanType([
    "==",
    [
        "geometry-type"
    ],
    "Point"
]);
const includeMultiPointFilter = cleanType([
    "==",
    [
        "geometry-type"
    ],
    "MultiPoint"
]);
const includeLineStringFilter = cleanType([
    "==",
    [
        "geometry-type"
    ],
    "LineString"
]);
const includeMultiLineStringFilter = cleanType([
    "==",
    [
        "geometry-type"
    ],
    "MultiLineString"
]);
const includePolygonFilter = cleanType([
    "==",
    [
        "geometry-type"
    ],
    "Polygon"
]);
const includeMultiPolygonFilter = cleanType([
    "==",
    [
        "geometry-type"
    ],
    "MultiPolygon"
]);
const clickFilter = cleanType([
    "==",
    [
        "feature-state",
        "click"
    ],
    true
]);
const hoverFilter = cleanType([
    "==",
    [
        "feature-state",
        "hover"
    ],
    true
]);
const customMapConfig = {
    lineColor: cleanType([
        "coalesce",
        [
            "get",
            "lineColor"
        ],
        [
            "get",
            "fillColor"
        ],
        _constants.DEFAULT_MAP_STYLES.lineColor
    ]),
    lineOpacity: cleanType([
        "case",
        [
            "any",
            clickFilter,
            hoverFilter
        ],
        _constants.DEFAULT_MAP_STYLES.lineOpacity,
        [
            "to-number",
            [
                "coalesce",
                [
                    "get",
                    "lineOpacity"
                ],
                _constants.DEFAULT_MAP_STYLES.lineOpacity
            ]
        ]
    ]),
    getLineWidth: ({ defaultWidth = 0, minWidth = 0 })=>cleanType([
            "max",
            minWidth,
            [
                "to-number",
                [
                    "coalesce",
                    [
                        "get",
                        "lineWidth"
                    ],
                    defaultWidth
                ]
            ]
        ]),
    getLineInteractionWidth: ({ defaultWidth = 0, minWidth = 0 })=>cleanType([
            "+",
            [
                "max",
                minWidth,
                [
                    "to-number",
                    [
                        "coalesce",
                        [
                            "get",
                            "lineWidth"
                        ],
                        defaultWidth
                    ]
                ]
            ],
            1
        ]),
    getFeatureColorForState: ({ defaultColor })=>cleanType([
            "case",
            customMapConfig.clickFilter,
            _styling.primitiveColors.blue500,
            customMapConfig.hoverFilter,
            _styling.primitiveColors.blue200,
            defaultColor
        ]),
    id: cleanType([
        "get",
        "id"
    ]),
    textField: cleanType([
        "get",
        "label"
    ]),
    fillColor: cleanType([
        "coalesce",
        [
            "get",
            "fillColor"
        ],
        transparent
    ]),
    fillOpacity: cleanType([
        "to-number",
        [
            "coalesce",
            [
                "get",
                "fillOpacity"
            ],
            _constants.DEFAULT_MAP_STYLES.fillOpacity
        ]
    ]),
    fillPattern: cleanType([
        "case",
        [
            "has",
            "fillColor"
        ],
        "",
        "shape-line"
    ]),
    iconImage: cleanType([
        "case",
        [
            "has",
            "icon"
        ],
        [
            "get",
            "icon"
        ],
        _constants.DEFAULT_MAP_STYLES.icon
    ]),
    iconImageFilled: cleanType([
        "case",
        [
            "has",
            "icon"
        ],
        [
            "concat",
            [
                "get",
                "icon"
            ],
            "-filled"
        ],
        `${_constants.DEFAULT_MAP_STYLES.icon}-filled`
    ]),
    iconSize: cleanType([
        "to-number",
        [
            "coalesce",
            [
                "get",
                "iconSize"
            ],
            _constants.DEFAULT_MAP_STYLES.iconSize
        ]
    ]),
    includePointFilter,
    includeMultiPointFilter,
    includeAllPointFilter: cleanType([
        "any",
        includePointFilter,
        includeMultiPointFilter
    ]),
    includeLineStringFilter,
    includeMultiLineStringFilter,
    includeAllLineStringFilter: cleanType([
        "any",
        includeLineStringFilter,
        includeMultiLineStringFilter
    ]),
    includePolygonFilter,
    includeMultiPolygonFilter,
    includeAllPolygonFilter: cleanType([
        "any",
        includePolygonFilter,
        includeMultiPolygonFilter
    ]),
    clickFilter,
    hoverFilter
};
const addNonceToUrl = (url, nonce)=>{
    const separator = url.includes("?") ? "&" : "?";
    return `${url}${separator}nonce=${nonce}`;
};
const generateDisplayName = ({ name, query, customObjectGroups = [] })=>{
    return `${(0, _queryBuilder.generateTableLabel)(query.source, customObjectGroups)} - ${name}`;
};

//# sourceMappingURL=data:application/json;base64,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